<template>
<div class="container pb-4 mb-4">

<div class="col-md-6 mx-auto">

    <div class="card mt-4 mb-2">
                <div class="card-header normal">Choose your timezone</div>
                    <div class="card-body">
  <v-select
    v-model="timezone"
    :options="timezones"
    label="name" 
    class="form-control2">
    <template #option="{ name }">
      <span>{{ name }}</span>
    </template>
  </v-select>

  <div class="pt-3">
    <button v-if="saving" type="button" class="btn btn-danger col"><i class="fas fa-spinner fa-spin"></i></button>
    <button v-else type="button" class="btn btn-danger col" @click="saveTimezone">Save</button>
  </div>

  </div>

    </div>
    </div>

</div>
</template> 

<script>
export default {
props: ['user','redirect'],
  data() {
    return {
      timezones: [],
      loading: false,
      saving: false,
      timezone: null,
    };
  },

  created() {
    this.getTimezones();
  },

  methods: {

    getTimezones() {

      this.loading = true;

      axios.get(`/timezones`).
      then((response) => {
        this.timezones = response.data;
      }).catch((error) => {
        this.sweetfire(error.response.data.message);
        this.loading = false;
      });

    },

    saveTimezone() {

      if (this.timezone==null) { this.sweetfire('Please choose your timezone'); return; }

      this.saving = true;

      axios.post('/profile/timezone', {
        timezone: this.timezone.value,
        }).
      then((response) => {
        window.location.href = this.redirect;
      }).catch((error) => {
        this.sweetfire(error.response.data.message);
        this.saving = false;
      });

    },

  },
};
</script>